import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/sent-info.png'


const _hoisted_1 = { class: "_invite-employee _modal bg-white" }
const _hoisted_2 = { class: "_modal__content px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "60",
    width: "60"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "w-full mt-10" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 font-normal w-2/5 font-semibold uppercase text-sm" }, " mục tiêu ", -1)
const _hoisted_8 = { class: "text-neutral-500 font-normal font-semibold uppercase text-sm" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center mt-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 font-normal w-2/5 font-semibold uppercase text-sm" }, " Lĩnh vực ", -1)
const _hoisted_12 = { class: "text-neutral-500 font-normal font-semibold uppercase text-sm" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex items-center mt-8" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 font-normal w-2/5 font-semibold uppercase text-sm" }, " người tạo ", -1)
const _hoisted_16 = { class: "text-neutral-500 font-normal font-semibold uppercase text-sm" }
const _hoisted_17 = { class: "flex items-center mt-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 font-normal w-2/5 font-semibold uppercase text-sm" }, " ngày tạo ", -1)
const _hoisted_19 = { class: "text-neutral-500 font-normal font-semibold uppercase text-sm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "flex items-center mt-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 font-normal w-2/5 font-semibold uppercase text-sm" }, " trạng thái ", -1)
const _hoisted_23 = { class: "font-normal font-semibold text-sm" }
const _hoisted_24 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_25 = {
  key: 1,
  class: "text-neutral-500"
}
const _hoisted_26 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " Thông tin " + _toDisplayString($props.data.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            ($props.data)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($props.data?.goal_count || 0), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            ($props.data)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($props.data?.skill_count || 0), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString($props.data.created_by_staff?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            ($props.data.inserted_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$filters.formatDateTime($props.data.inserted_at)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            ($props.data.is_completed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Hoàn thành "))
              : (_openBlock(), _createElementBlock("span", _hoisted_25, " Bản nháp "))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Đóng ")
    ])
  ]))
}